/*eslint-disable*/export const messages = {
  'Add "{inputValue}"': ['Adicionar "', ["inputValue"], '"'],
  "All items have been removed.": "Todos os itens foram removidos.",
  "Clear selection": "Limpar seleção",
  "No results found.": "Nenhum resultado encontrado.",
  "Press Enter to select or deselect an option.": "Pressione Enter para selecionar ou desmarcar uma opção.",
  "Select All": "Selecionar tudo",
  "Selected Items": "Itens selecionados",
  "Toggle menu": "Ativar/desativar menu",
  "listbox contents": "conteúdo da caixa de listagem",
  "{itemAsString} has been removed.": [["itemAsString"], " foi removido."],
  "{itemAsString} has been selected.": [["itemAsString"], " foi selecionado."],
  "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.": [["resultCount", "plural", {
    one: ["#", " resultado"],
    other: ["#", " resultados"]
  }], " disponível(is). Use as teclas de seta para cima e para baixo para navegar. Pressione a tecla Enter para selecionar."],
  "{selectedValue} selected": [["selectedValue"], " selecionado"],
  "{totalSelectedItems} selected": [["totalSelectedItems"], " selecionados"],
  "{totalSelectedItems} selected. Deselect all": [["totalSelectedItems"], " selecionados. Desmarcar todos"],
  "{totalSelectedItems} selected. Select all {totalOptions} items": [["totalSelectedItems"], " selecionados. Selecionar todos os ", ["totalOptions"], " artigos"]
};
//# sourceMappingURL=messages.js.map